import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditorAuthGuard } from '../guards/editor-auth.guard';
import { PageUrls, PageUrlsParts } from '../helpers/page-urls';
import { RawImageManageComponent, RawImagePendingGroupedComponent } from './components/raw-image';
import { EditorComponent } from './editor.components';

const routes: Routes = [
    {
        path: PageUrlsParts.Editor.Self,
        component: EditorComponent,
        canActivate: [EditorAuthGuard],
        children: [
            { path: '', redirectTo: PageUrls.Editor.Dashboard, pathMatch: 'full' },
            { path: PageUrlsParts.Editor.PendingGrouped, component: RawImagePendingGroupedComponent },
            { path: PageUrlsParts.Editor.RawImageManage, component: RawImageManageComponent },
        ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EditorRoutingModule { }
